import React, { useState, useEffect } from "react";
import { Spin, Select, Checkbox } from "antd";
const { Option } = Select;

import Axios from "axios";
import { Button1, CheckBoxInput } from "../../../../Buttons";
import TextInputModal from "../../../../TextInputModal";
import { have_product_reference } from "../../../../../../helpers/OrdersFunctionsGlobal";
// Custom

function OrderRowAdd({
  postOrderRowGoods,
  orderId,
  mode,
  order_shop_id,
  order_rows,
}) {
  const [LoadingRes, setLoadingRes] = useState(false);
  const [Goods, setGoods] = useState([]);
  const [SearchText, setSearchText] = useState("");
  const [Loading, setLoading] = useState(false);
  const [Timer, setTimer] = useState(0);
  const [SelectedItem, setSelectedItem] = useState(undefined);
  const [rowFromServer, setRowFromServer] = useState("goods");
  const [errors, setErrors] = useState({});
  const [autoPriceMode, setAutoPriceMode] = useState(false);
  const [autoPriceMessage, setAutoPriceMessage] = useState("");
  const [autoPricePlan, setAutoPricePlan] = useState(null);
  const [pricingResolved, setPricingResolved] = useState(false);

  // useEffect(() => {
  //   if (mode == "Servisas") {
  //     handleChangeCheckBox("other");
  //   }
  // }, [mode]);

  const fetchGoods = (value) => {
    setSearchText(value);
    if (Timer) {
      clearTimeout(Timer);
    }
    setTimer(
      setTimeout(() => {
        if (value.length >= 3) {
          setLoading(true);
          Axios.get(
            `/api/v1/products/meilisearch_products?q[title_or_identifier_i_cont_any]=${value}`
          )
            .then((response) => {
              if (response.data) {
                const data = response.data.data.map((product) => ({
                  quantity: product.quantity,
                  product_name: product.title,
                  product_price: product.e_price,
                  unit_price_tax_incl: product.e_price,
                  unit_price_tax_excl: product.e_price,
                  product_reference: product.identifier,
                  barcode: "",
                  parent_id: null,
                }));
                setGoods(data);
                // setSearchText("");
              }
            })
            .catch(() => setGoods([]))
            .finally(() => {
              setLoading(false);
            });
        } else {
          // setSearchText("Minimum 3 characters");
        }
      }, 1000)
    );
  };

  const fetchRivileService = (value) => {
    setSearchText(value);
    if (Timer) {
      clearTimeout(Timer);
    }
    setTimer(
      setTimeout(() => {
        if (value.length >= 3) {
          setLoading(true);
          Axios.get(
            `/api/v1/rivile_services?page=1&per_page=9999999&q[title_i_cont_any]=${value}&q[order_shops_id_eq]=${order_shop_id}`
          ).then((response) => {
            if (response.data) {
              const data = response.data.data.map((product) => ({
                id: product.id,
                quantity: 1,
                product_name: product.title,
                product_reference: "{}",
                product_price: product.alt_price,
                unit_price_tax_incl: product.alt_price,
                unit_price_tax_excl: product.alt_price,
                id_product: product.id_product,
                rivile_service_id: product.id,
                barcode: "",
                parent_id: null,
              }));
              setGoods(data);
              // setSearchText("");
              setLoading(false);
            }
          });
        } else {
          // setSearchText("Minimum 3 characters");
        }
      }, 1000)
    );
  };

  const resolveServicePricingMode = async (value) => {
    if (rowFromServer !== "service") {
      resetAutoPrice();
      return;
    }

    try {
      const response = await Axios.get(
        `/api/v1/orders/${orderId}/order_rows/service_pricing_mode`,
        {
          params: {
            rivile_service_id: value?.rivile_service_id,
            id_product: value?.id_product,
          },
        }
      );
      const autoPrice = !!response?.data?.auto_price;
      setAutoPriceMode(autoPrice);
      setAutoPriceMessage(response?.data?.message || "");
      setAutoPricePlan(
        autoPrice
          ? {
              percentage: Number(response?.data?.percentage || 0),
              base_price: Number(response?.data?.base_price || 0),
              plan_name: response?.data?.plan_name,
            }
          : null
      );
      setPricingResolved(true);
    } catch (_error) {
      resetAutoPrice();
    }
  };

  const resetAutoPrice = () => {
    setAutoPriceMode(false);
    setAutoPriceMessage("");
    setAutoPricePlan(null);
    setPricingResolved(false);
  };

  const parentRow = order_rows?.find(
    (row) => row.id == SelectedItem?.parent_id
  );
  const parentPrice = Number(parentRow?.unit_price_tax_incl || 0);
  const adminFee = autoPricePlan
    ? Number(autoPricePlan.base_price.toFixed(2))
    : 0;
  const serviceFee = autoPricePlan
    ? Number(((parentPrice * autoPricePlan.percentage) / 100).toFixed(2))
    : 0;
  const splitAdminFee = adminFee > 0 && serviceFee > 0;
  const calculatedServicePrice = autoPricePlan
    ? splitAdminFee
      ? serviceFee
      : Number((serviceFee + adminFee).toFixed(2))
    : null;

  useEffect(() => {
    if (!autoPriceMode || calculatedServicePrice === null) {
      return;
    }
    setSelectedItem((prev) =>
      prev
        ? {
            ...prev,
            product_price: calculatedServicePrice,
            unit_price_tax_incl: calculatedServicePrice,
            unit_price_tax_excl: calculatedServicePrice,
          }
        : prev
    );
  }, [autoPriceMode, calculatedServicePrice]);

  const handleChange = (value) => {
    setSelectedItem((prev) => ({ ...(prev || {}), ...value }));
  };

  const handleSelectChange = async (value) => {
    const merged = { ...(SelectedItem || {}), ...value };
    setSelectedItem(merged);
    await resolveServicePricingMode(merged);
  };

  const onUpdate = () => {
    if (SelectedItem.product_name.trim() === "") {
      return setErrors({ title: "Enter the text" });
    }
    if (rowFromServer == "service" && !SelectedItem.parent_id) {
      return setErrors({ parent_id: "Assign to product" });
    }
    setLoadingRes(true);
    const body = {
      order_row: {
        quantity: SelectedItem.quantity,
        order_id: orderId,
        id_product: SelectedItem.id_product || null,
        product_name: SelectedItem.product_name,
        product_price: SelectedItem.unit_price_tax_incl,
        product_reference: SelectedItem.product_reference,
        unit_price_tax_incl: SelectedItem.unit_price_tax_incl,
        unit_price_tax_excl: SelectedItem.unit_price_tax_incl,
        barcode: SelectedItem.barcode,
        parent_id: SelectedItem.parent_id,
        manual: 1,
      },
    };
    postOrderRowGoods(body, orderId, rowFromServer == "goods").then((res) => {
      if (res.ok) {
        if (res.service) {
          setLoadingRes(false);
          handleChangeCheckBox("other");
          setErrors({});
        } else {
          setErrors({});
          setSelectedItem(undefined);
          setRowFromServer(true);
          setLoadingRes(false);
        }
      } else {
        setLoadingRes(false);
        setErrors({ error: "Error occurred" });
        // notifications("error", "Error occurred");
      }
    });
  };

  const handleChangeCheckBox = (boolean) => {
    if (boolean !== "other") {
      setSelectedItem(undefined);
      setRowFromServer(boolean);
      setGoods([]);
      resetAutoPrice();
    } else {
      setSelectedItem({
        quantity: 1,
        id_product: "",
        product_name: "",
        product_price: 0,
        product_reference: "{}",
        unit_price_tax_incl: 0,
        unit_price_tax_excl: 0,
        barcode: "",
        parent_id: null,
      });
      setRowFromServer(boolean);
      resetAutoPrice();
    }
  };

  if (LoadingRes) {
    return (
      <div className="d-flex align-items-center justify-content-center my-4">
        <Spin tip="Loading..." />
      </div>
    );
  }
  return (
    <React.Fragment>
      <div className="col-12 bg-silver pt-2 pb-3">
        <p className="bg-silver font-weight-bold mb-1">Add</p>
        <div className="pb-3 pt-2">
          <Checkbox
            checked={rowFromServer == "goods"}
            onChange={() => handleChangeCheckBox("goods")}
          >
            Product search
          </Checkbox>
          {!!order_shop_id && (
            <Checkbox
              checked={rowFromServer == "service"}
              onChange={() => handleChangeCheckBox("service")}
            >
              Service search
            </Checkbox>
          )}
          {mode == "Service" && (
            <Checkbox
              checked={rowFromServer == "other"}
              onChange={() => handleChangeCheckBox("other")}
            >
              Other
            </Checkbox>
          )}
        </div>

        {rowFromServer !== "other" && (
          <Select
            showSearch
            // mode="multiple"
            labelInValue
            value={SelectedItem}
            placeholder={"Choose"}
            notFoundContent={
              Loading ? (
                <div className="d-flex justify-content-center">
                  <Spin size="small" />
                </div>
              ) : null
            }
            filterOption={false}
            onSearch={
              rowFromServer == "goods" ? fetchGoods : fetchRivileService
            }
            onChange={(_, value) => handleSelectChange(value)}
            style={{ width: "100%" }}
          >
            {Goods.map((d, idx) => (
              <Option
                key={`${rowFromServer == "goods" ? "goods" : "service"}_${
                  d.id || "_"
                }_${idx}`}
                id_product={d.id_product}
                rivile_service_id={d.rivile_service_id}
                quantity={1}
                product_name={d.product_name}
                product_price={d.product_price}
                unit_price_tax_incl={d.unit_price_tax_incl}
                product_reference={d.product_reference}
                unit_price_tax_excl={d.unit_price_tax_excl}
              >
                {d.product_name}
              </Option>
            ))}
          </Select>
        )}
        {SearchText.length >= 1 && SearchText.length < 3 && (
          <p className="text-danger">Minimum 3 characters</p>
        )}
        {typeof SelectedItem !== "undefined" && (
          <React.Fragment>
            <div className="d-flex">
              <div style={{ width: "50%" }}>
                <TextInputModal
                  text="Name"
                  placeholder="Enter"
                  value={SelectedItem.product_name}
                  onChange={(e) =>
                    handleChange({ product_name: e.target.value })
                  }
                  warning={errors.title}
                />
              </div>
              <div className="px-2" style={{ width: "25%" }}>
                <TextInputModal
                  // disabled={mode === "Servisas"}
                  type="number"
                  text="Quantity"
                  placeholder="Enter"
                  value={SelectedItem.quantity}
                  onChange={(e) => handleChange({ quantity: e.target.value })}
                />
              </div>
              <div style={{ width: "25%" }}>
                <TextInputModal
                  type="number"
                  text="Price"
                  placeholder="Enter"
                  disabled={rowFromServer == "service" && autoPriceMode}
                  value={SelectedItem.unit_price_tax_incl}
                  onChange={(e) =>
                    handleChange({ unit_price_tax_incl: e.target.value })
                  }
                />
              </div>
              {rowFromServer == "other" && (
                <div className="pl-2" style={{ width: "50%" }}>
                  <TextInputModal
                    text="Barcode"
                    placeholder="Enter"
                    value={SelectedItem.barcode}
                    onChange={(e) => handleChange({ barcode: e.target.value })}
                  />
                </div>
              )}
            </div>
            {rowFromServer == "service" && (
              <>
                {autoPriceMode && (
                  <div className="text-info mt-2">
                    <div>
                      {autoPriceMessage}
                      {autoPricePlan?.plan_name
                        ? ` (${autoPricePlan.plan_name})`
                        : ""}
                    </div>
                    {parentRow ? (
                      splitAdminFee ? (
                        <>
                          <div>
                            {`Service: ${autoPricePlan?.percentage}% of ${parentPrice.toFixed(
                              2
                            )} € = ${serviceFee.toFixed(2)} €`}
                          </div>
                          <div>
                            {`Administration fee: ${adminFee.toFixed(
                              2
                            )} € - added as a separate row`}
                          </div>
                        </>
                      ) : (
                        <div>
                          {`Service: ${adminFee.toFixed(2)} € + ${
                            autoPricePlan?.percentage
                          }% of ${parentPrice.toFixed(
                            2
                          )} € = ${calculatedServicePrice?.toFixed(2)} €`}
                        </div>
                      )
                    ) : (
                      <div>
                        Assign the service to a product below - its price is used
                        for the calculation.
                      </div>
                    )}
                  </div>
                )}
                {pricingResolved && !autoPriceMode && (
                  <div className="text-warning font-weight-bold mt-2">
                    No document plan is set for this service - enter the price
                    manually.
                  </div>
                )}
                <AdditionallyService
                  order_rows={order_rows}
                  handleChange={handleChange}
                  SelectedItem={SelectedItem}
                  error={errors?.parent_id}
                />
              </>
            )}
            {errors.error && <div className="text-danger">{errors.error}</div>}
            <div
              className="my-2"
              style={{ position: "relative", height: "35px" }}
            >
              <Button1
                style={{
                  position: "absolute",
                  left: "50%",
                  transform: "translate(-50%, 0px)",
                }}
                text={"Add"}
                option={"plus"}
                onClick={() => onUpdate()}
              />
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
}
export default OrderRowAdd;

const AdditionallyService = ({
  order_rows,
  handleChange,
  SelectedItem,
  error,
}) => {
  order_rows = order_rows?.filter(({ product_reference }) =>
    have_product_reference(product_reference)
  );
  if (!order_rows?.length) {
    return null;
  }

  return (
    <div className="mb-2">
      <p
        className="mb-0 mt-2"
        style={{
          color: error ? "red" : "rgba(0, 0, 0, 0.4)",
        }}
      >
        Additionally assign service to product
      </p>
      {order_rows?.map(({ product_reference, product_name, id }, idx) => (
        <div
          className="my-1"
          key={id}
          style={{
            borderBottom:
              order_rows.length !== idx + 1 ? "1px solid #DEE2E6" : "none",
          }}
        >
          <CheckBoxInput
            checked={SelectedItem.parent_id == id}
            text={`(${product_reference}) ${product_name}`}
            onChange={() => {
              handleChange({
                parent_id: SelectedItem.parent_id == id ? null : id,
              });
            }}
          />
        </div>
      ))}
      {!!error && <div className="text-danger text-sm">{error}</div>}
    </div>
  );
};
